exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardSubcontractorsOverall-981f9{margin-bottom:40px;padding:16px 24px;background-color:#fff}", ""]);

// Exports
exports.locals = {
	"dashboardSubcontractorsOverall": "dashboardSubcontractorsOverall-981f9"
};